import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  Link,
  Stack,
  IconButton,
} from "@mui/material";
import { Facebook, Mail, Chat } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";

const Footer = () => {

  const dispatch = useDispatch();
  const lang = useSelector((state) => state.language.lang);

  const aboutUsLinks = [
    {
      name: lang === "en" ? "About Us" : "ကျွန်ုပ်တို့အကြောင်း",
      link: "/about-us",
    },
    // {
    //   name: lang === "en" ? "Partnership" : "မိတ်ဖက်ဆက်ဆံရေး",
    //   link: "/",
    // },
    // {
    //   name: lang === "en" ? "Payment Channels" : "ငွေပေးချေမှု လမ်းကြောင်းများ",
    //   link: "/",
    // },
  ];

  const productTypes = [
    {
      name: lang === "en" ? "Hire-Purchase Loan" : "အရစ်ကျချေးငွေ",
      link: "/apply-now",
    },
    {
      name:
        lang === "en"
          ? "Owner Book Loan"
          : "အုံနာဘုတ်ချေးငွေ",
      link: "/apply-now",
    },
    {
      name: lang === "en" ? "Cash Loan" : "ငွေသားချေးငွေ",
      link: "/apply-now",
    },
    {
      name: lang === "en" ? "Education Loan" : "ပညာရေးချေးငွေ",
      link: "/apply-now",
    },
    {
      name: lang === "en" ? "Travel Loan" : "ခရီးသွားချေးငွေ",
      link: "/apply-now",
    },
    {
      name: lang === "en" ? "Insurance Loan" : "အာမခံချေးငွေ",
      link: "/apply-now",
    },
  ];

  const loanCalculator = [
    {
      name: lang === "en" ? "Loan Calculator" : "ချေးငွေတွက်ချက်ရန်",
      link: "/loan-calculator",
    },
    {
      name:
        lang === "en"
          ? "Eligibility Calculator"
          : "ချေးငွေအကျုံးဝင်မှုတွက်ချက်ရန်",
      link: "/loan-calculator",
    },
  ];

  const contactUs = [
    {
      name: lang === "en" ? "Contact Us" : "ဆက်သွယ်ရန်",
      link: "/contact",
    },
    {
      name: lang === "en" ? "FAQs" : "မေးလေ့ရှိသောမေးခွန်းများ",
      link: "/faq",
    },
  ];

  return (
    <Box sx={{ backgroundColor: "#1F3764", color: "#fff", pt: 6, pb: 3 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* About Us */}
          <Grid item xs={12} md={3}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontSize: "1.4rem", fontWeight: "bold" }}
            >
              {lang === "en" ? "About Us" : "ကျွန်ုပ်တို့အကြောင်း"}
            </Typography>
            <List disablePadding>
              {aboutUsLinks.map((item, idx) => (
                <ListItem key={idx} disableGutters sx={{ py: 0.5 }}>
                  <Link href={item.link} underline="hover" color="inherit">
                    <ListItemText primary={item.name} />
                  </Link>
                </ListItem>
              ))}
            </List>
          </Grid>

          {/* Product Types */}
          <Grid item xs={12} md={3}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontSize: "1.4rem", fontWeight: "bold" }}
            >
              {lang === "en" ? "Product Types" : "ထုတ်ကုန်အမျိုးအစားများ"}
            </Typography>
            <List disablePadding>
              {productTypes.map((item, idx) => (
                <ListItem key={idx} disableGutters sx={{ py: 0.2 }}>
                  <Link href={item.link} underline="hover" color="inherit">
                    <ListItemText primary={item.name} />
                  </Link>
                </ListItem>
              ))}
            </List>
          </Grid>

          {/* Loan Calculator */}
          <Grid item xs={12} md={3}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontSize: "1.4rem", fontWeight: "bold" }}
            >
              {lang === "en" ? "Loan Calculator" : "ချေးငွေတွက်ချက်ရန်"}
            </Typography>
            <List disablePadding>
              {loanCalculator.map((item, idx) => (
                <ListItem key={idx} disableGutters sx={{ py: 0.5 }}>
                  <Link href={item.link} underline="hover" color="inherit">
                    <ListItemText primary={item.name} />
                  </Link>
                </ListItem>
              ))}
            </List>
          </Grid>

          {/* Contact Us */}
          <Grid item xs={12} md={3}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontSize: "1.4rem", fontWeight: "bold" }}
            >
              {lang === "en" ? "Contact Us" : "ဆက်သွယ်ရန်"}
            </Typography>
            <List disablePadding>
              {contactUs.map((item, idx) => (
                <ListItem key={idx} disableGutters sx={{ py: 0.5 }}>
                  <Link href={item.link} underline="hover" color="inherit">
                    <ListItemText primary={item.name} />
                  </Link>
                </ListItem>
              ))}
            </List>
          </Grid>
        </Grid>

        {/* Bottom Section */}
        <Stack direction="row" spacing={2} justifyContent="end" sx={{ mb: 2, mt: 1 }}>
          <IconButton sx={{ color: "#fff" }} href="mailto:info@momofinance.com">
            <Mail sx={{ fontSize: 30 }} />
          </IconButton>
          <IconButton
            sx={{ color: "#fff" }}
            href="https://facebook.com/momofinance"
            target="_blank"
          >
            <Facebook sx={{ fontSize: 30 }} />
          </IconButton>
          <IconButton
            sx={{ color: "#fff" }}
            href="https://m.me/momofinance"
            target="_blank"
          >
            <Chat sx={{ fontSize: 30 }} />
          </IconButton>
        </Stack>

        <Box
          mt={4}
          pt={2}
          borderTop="1px solid rgba(255,255,255,0.1)"
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="body2"
            sx={{
              textAlign: { xs: "center", md: "left" },
              mb: { xs: 2, md: 0 },
            }}
          >
            {lang === "en"
              ? "Please read carefully the terms and conditions before proceeding with a loan transaction."
              : "ချေးငွေလုပ်ငန်းစဉ်လုပ်ဆောင်ရန်မတိုင်မီ စည်းကမ်းချက်များကို ဂရုတစိုက်ဖတ်ပါ။"}
          </Typography>
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              {lang === "en"
                ? "All Rights Reserved © 2025 Mo Mo Finance"
                : "မူပိုင်ခွင့်အားလုံး ထားရှိပါသည် © 2024 Mo Mo Finance"}
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
